import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../API/EndPoints";
import AxiosInstance from "../API/AxiosInstance";

export const getAppointmentHistory = createAsyncThunk(
  "master/getAppointmentHistory",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        API_ENDPOINTS.APPOINTMENT_HISTORY
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const appointmentHistorySlice = createSlice({
  name: "getAppointmentHistory",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAppointmentHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAppointmentHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getAppointmentHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default appointmentHistorySlice.reducer;
